<template>
  <div style="display: flex; align-items: center;">
    <b-icon
      class="has-text-aquamarine"
      style="margin-right: 10px;"
      pack="fa"
      icon="filter"
    ></b-icon>
    <b-field
      v-for="f in filter[resourceType].filters"
      :key="f.value"
      style="margin-bottom: 0px; margin-right: 10px;"
    >
      <b-input
        v-if="f.type === 'input'"
        v-model="filter[resourceType].filter[f.value]"
        :placeholder="$gettext(f.label)"
        :style="f.style"
        :icon="f.icon"
        @input="onFilter"
      ></b-input>
      <b-select
        v-if="f.type === 'select'"
        v-model="filter[resourceType].filter[f.value]"
        @input="onFilter"
        :placeholder="$gettext(f.label)"
      >
        <!-- no selection -->
        <option
          :value='null'
          class="is-italic"
        >
          <translate>AboutMe.select.reset</translate>
        </option>
        <!-- filters on research activity from store -->
        <option
          v-for="filterOption in f.options"
          :key="filterOption"
          :value="filterOption">
            <translate>
              {{`AboutMe.filter.${f.value}.${filterOption.toLowerCase()}`}}
            </translate>
        </option>
      </b-select>
    </b-field>
  </div>
</template>

<script>

import { mapGetters } from 'vuex'
import debounce from 'debounce'
import AboutMeHelper from '@/components/mixins/AboutMeHelper'

export default {
  name: 'fob-aboutme-list-filter',
  props: ['resourceType'],
  mixins: [AboutMeHelper],
  computed: {
    ...mapGetters({
      filter: 'aboutme/getFilter'
    })
  },
  methods: {
    onFilter: debounce(function () {
      this.setFirstPage()
      this.loadAsyncData()
    }, 500)
  }
}

</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/aboutme/AboutMeListFilter.vue